import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d8f71b54&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f71b54')) {
      api.createRecord('d8f71b54', component.options)
    } else {
      api.reload('d8f71b54', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d8f71b54&", function () {
      api.rerender('d8f71b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Delivery/index.vue"
export default component.exports